import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { SubscriptionsContainer } from '../../components/Subscriptions'

export const Subscriptions = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'subscriptions'} />

      <SubscriptionsContainer />
    </>
  )
}
